import { render, staticRenderFns } from "./ChatItemUniversal.vue?vue&type=template&id=bba1f93a&scoped=true"
import script from "./ChatItemUniversal.vue?vue&type=script&lang=js"
export * from "./ChatItemUniversal.vue?vue&type=script&lang=js"
import style0 from "./ChatItemUniversal.vue?vue&type=style&index=0&id=bba1f93a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bba1f93a",
  null
  
)

export default component.exports